import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#191056",
        color: "white",
        textAlign: "center",
        padding: "12px",
        fontSize: "14px",
        width: "100%",
        position: "relative",
        // bottom: "2px", // 2px gap from the bottom
      }}
    >
      © {new Date().getFullYear()} X Vector Technologies Pvt. Ltd. All Rights Reserved.
    </footer>
  );
};

export default Footer;
